import { PAYMENT_V2_ENDPOINT_V2 } from "@/components/Pricing/v2/constants.pricing";
import { TCloudAPIResponse } from "@/types/app";
import axios from "axios";

export type TPaymentMethodCard = {
  brand: string;
  country: string;
  expiry_month: number;
  expiry_year: number;
  last4: string;
};

export type TPaymentMethodLink = {
  owner_email: string;
};

export type TPaymentMethod = {
  id: string;
  type: "card" | "us_bank_account" | "link";
  card: TPaymentMethodCard | null;
  link: TPaymentMethodLink | null;
  image_url?: string;
};

interface GetPaymentDetailOption {
  token: string;
}

type TResponse = TCloudAPIResponse<TPaymentMethod[]>;

const APIURL = `${PAYMENT_V2_ENDPOINT_V2}/user/payment-methods`;

export async function getPaymentDetail(
  option: GetPaymentDetailOption,
): Promise<TResponse> {
  try {
    const response = await axios.get(APIURL, {
      headers: {
        Authorization: option.token,
      },
    });

    return response.data as TResponse;
  } catch (error: any) {
    console.error("Error fetching payment details:", error);
    throw error;
  }
}
